import { watch, type Ref } from 'vue'

interface UseNewOrderModalLifecycleOptions<TOrder> {
  open: Ref<boolean>
  isEditMode: Ref<boolean>
  orderToEdit: Ref<TOrder | null | undefined>
  menuItemsCount: Ref<number>
  formItemsCount: Ref<number>
  resetForm: () => void
  initializeFormItemsFromMenu: () => void
  applyOpenTableSelection: () => void
  loadOrderIntoForm: (order: TOrder) => void | Promise<void>
  emitClose: () => void
}

export function useNewOrderModalLifecycle<TOrder>(options: UseNewOrderModalLifecycleOptions<TOrder>) {
  const handleModalClose = () => {
    options.emitClose()
  }

  const hydrateOnMountedIfEditing = () => {
    if (options.isEditMode.value && options.orderToEdit.value) {
      void options.loadOrderIntoForm(options.orderToEdit.value)
    }
  }

  watch(
    () => options.orderToEdit.value,
    (newOrder) => {
      if (options.isEditMode.value && newOrder && options.open.value) {
        void options.loadOrderIntoForm(newOrder)
      }
    }
  )

  watch(
    () => options.open.value,
    (isOpen, wasOpen) => {
      if (!isOpen && wasOpen) {
        options.resetForm()
        return
      }

      if (!isOpen || wasOpen) {
        return
      }

      if (options.formItemsCount.value === 0 && options.menuItemsCount.value > 0) {
        options.initializeFormItemsFromMenu()
      }

      options.applyOpenTableSelection()

      if (options.isEditMode.value && options.orderToEdit.value) {
        void options.loadOrderIntoForm(options.orderToEdit.value)
      }
    }
  )

  return {
    handleModalClose,
    hydrateOnMountedIfEditing
  }
}
